module.exports = __webpack_public_path__ + "static/media/note5.7898b605.wav";